import { Component, model, output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../ui/button/button';
import { CheckCircle } from '../../icons/check-circle/check-circle';
import { XClose } from '../../icons/x-close/x-close';

@Component({
  standalone: true,
  selector: 'app-confirm-payment-dialog',
  imports: [Dialog, ButtonComponent, CheckCircle, XClose],
  templateUrl: './confirm-payment-dialog.html',
  styleUrl: './confirm-payment-dialog.scss',
})
export class ConfirmPaymentDialog {
  isVisible = model.required<boolean>();

  confirmed = output<void>();
  cancelled = output<void>();

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
